import { render, staticRenderFns } from "./modify.vue?vue&type=template&id=024e6dd4&scoped=true&"
import script from "./modify.vue?vue&type=script&lang=ts&"
export * from "./modify.vue?vue&type=script&lang=ts&"
import style0 from "./modify.vue?vue&type=style&index=0&id=024e6dd4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024e6dd4",
  null
  
)

export default component.exports